import { Component, Prop, Vue } from 'vue-property-decorator';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import FormFieldInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-field-interface';
import FormInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-interface';
import Techspec from '@/model/entity/job/techspec';

@Component
export default class TechspecDuplicateForm extends Vue
{
    @Prop()
    private techspec!: Techspec;

    private form: FormInterface|null = null;
    private saving = false;

    private created()
    {
        this.generateForm();
    }

    /**
     * Handles form saves
     *
     * @param form
     */

    private async onSave(form: FormInterface)
    {
        if (!this.techspec.id)
        {
            return;
        }

        this.saving = true;

        // Get the client id from the form
        const clientId = (form.items[0] as FormFieldInterface).value as number;

        try
        {
            // Duplicate the techspec
            const duplicateId = await this.$serviceContainer.techspecService.duplicateTechspec(this.techspec.id, clientId);

            // Emit an event with the duplicate id
            this.$emit('duplicated', duplicateId);

            EventBus.instance.$emit(
                'notification',
                this.$t('general.message.duplicated_successfully'),
                'success',
            );
        }
        catch (error: unknown)
        {
            EventBus.instance.$emit(
                'notification',
                this.$t('general.error.failed_duplicating_server_error'),
                'error',
            );
        }
        finally
        {
            this.saving = false;
        }
    }

    /**
     * Generates the form
     */

    private generateForm()
    {
        if (!this.techspec)
        {
            this.form = null;
            return;
        }

        const form: FormInterface =
        {
            items: [
                {
                    key: 'client',
                    type: 'integer',
                    title: this.$t('techspec.field.target_client').toString(),
                    value: null,
                    required: true,
                    optionsCallback: async(search: string) => this.$serviceContainer.clientService.clientFormOptionsCallback(search),
                    titlesCallback: async(values: string[]) => this.$serviceContainer.clientService.clientFormTitlesCallback(values),
                },
            ],
            cancelButton: true,
        };

        this.form = Object.assign({}, form);
    }
}